// extracted by mini-css-extract-plugin
export default {"activateAccount":"KYCBlock_activateAccount__KO7-t","error":"KYCBlock_error__iy2rO"};